/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   isProUser util
 */

import type { User } from '@zcode/bizos'
import { UserRole } from '@zcode/enums'

const proRoles = [UserRole.LANDLORD, UserRole.AGENT, UserRole.BUILDING_REPRESENTATIVE]

const hasRole = (roleEnum: number, roles?: number | null) => {
  const bitNumber = Math.pow(2, roleEnum)

  return roles && !!(bitNumber & roles)
}

export const isProUser = (user: User) => {
  if (!user) {
    return false
  }

  return proRoles.some((role) => hasRole(role, user.roles))
}
